// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

const SettingStore = createStore({
  storeName: 'SettingStore',

  initialize() {
    this.reset();
  },

  getSetting(key: $TSFixMe) {
    const setting = this.settings[key];
    return setting || this._getDefaultEmpty();
  },

  getSettings() {
    return this.settings;
  },

  reset() {
    this.settings = {};
    this.settingsLoaded = false;
  },

  hasLoaded() {
    return this.settingsLoaded;
  },

  _getDefaultEmpty() {
    // return null, when there is no setting, but undefined when data is not loaded yet
    return this.settingsLoaded ? null : undefined;
  },
});

SettingStore.handlers = {
  LOAD_SETTINGS({ settings }: $TSFixMe) {
    settings.forEach((setting: $TSFixMe) => {
      this.settings[setting.key] = setting.setting;
    }, this);
    this.settingsLoaded = true;
    this.emitChange();
  },
  INIT_SETTINGS() {
    this.reset();
  },
};

export default SettingStore;
